module.exports = __webpack_public_path__ + "img/building.d27828f.png";